import { render } from "./open-transaction-cell.vue?vue&type=template&id=dfa88dd6"
import script from "./open-transaction-cell.vue?vue&type=script&lang=js"
export * from "./open-transaction-cell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__